import { render } from "./RecordView.vue?vue&type=template&id=d78dc4a0&scoped=true&ts=true"
import script from "./RecordView.vue?vue&type=script&lang=ts"
export * from "./RecordView.vue?vue&type=script&lang=ts"

import "./RecordView.vue?vue&type=style&index=0&id=d78dc4a0&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78dc4a0"]])

export default __exports__